import { api } from '@/lib/api/client'
import { fetchAll } from '@/lib/api/paged'

/** Every kind the server sends. A kind with no label is a bug, not a fallback. */
export type NotificationKind = 'mentioned' | 'assigned' | 'commented' | 'sla_breached'

export interface AppNotification {
  id: string
  kind: NotificationKind
  /** The words as they were when it was written, so a renamed record still reads right. */
  payload: { key?: string; title?: string; excerpt?: string; workItemId?: string; attachmentId?: string }
  subjectType: string
  subjectId: string
  projectId: string | null
  readAt: string | null
  createdAt: string
  actor?: { id: string; name: string; color: string | null } | null
}

export async function fetchNotifications(unreadOnly = false): Promise<AppNotification[]> {
  return fetchAll<AppNotification>('/notifications', unreadOnly ? { unread: 1 } : {})
}

/**
 * Just the number. Polled, unlike the list — a badge that costs fifty rows and
 * their actors every thirty seconds is a badge somebody turns off.
 */
export async function fetchUnreadCount(): Promise<number> {
  const { data } = await api.get<{ data: { unread: number } }>('/notifications/count')

  return data.data.unread
}

export async function markRead(id: string): Promise<void> {
  await api.post(`/notifications/${id}/read`, {})
}

export async function markAllRead(): Promise<void> {
  await api.post('/notifications/read-all', {})
}
